import React, {createContext, useContext, useState} from 'react';
import UploadFile from './components/upload-file';
import ListUploadFile from './components/list-upload-file';
import {useDocuments} from './hooks/useDocuments';
import './style/document.scss'
import PropTypes from "prop-types";

export const DocumentContext = createContext({});
export const useDocumentContext = () => useContext(DocumentContext);

const SimpleDocument = ({
                            externalReferenceCode,
                            referenceCodeItem,
                            moduleId,
                            appId,
                            readonly,
                            primaryColor,
                            isSingle,
                            radioSelect,
                            ...props
                        }) => {
    const [listProgressFiles, setListProgressFiles] = useState({});

    const [reloadData, setReloadData] = useState(false);

    const onAfterSuccess = () => {

        Object.keys(listProgressFiles)?.forEach(key => {

            if (listProgressFiles[key].percent === 100) {
                setListProgressFiles(state => {

                    const clone = {...state}

                    delete clone[key]

                    return clone
                });
            }
        });

        setReloadData(false);
    };

    const onAfterError = () => {

    };

    const [dataSource] = useDocuments(
        {type: 'file', pkCode: externalReferenceCode, appId, moduleId, sort: "modifiedDate:desc"},
        [
            reloadData,
            externalReferenceCode,
            referenceCodeItem,
            appId,
            moduleId
        ],
        onAfterSuccess,
        onAfterError
    );

    const renderNewDataSource = () => {

        const newDataSource = {};

        dataSource?.forEach((item) => {

            newDataSource[item.externalReferenceCode] = item;
        });

        return newDataSource;
    };

    const value = {
        primaryColor,
        externalReferenceCode,
        moduleId,
        appId,
        readonly,
        dataSource,
        newDataSource: renderNewDataSource(),
        listProgressFiles,
        setListProgressFiles,
        setReloadData,
        isSingle,
        radioSelect
    };

    return (
        <DocumentContext.Provider
            value={value}
        >
            <div className={'simple-document-wrapper'}>
                <UploadFile accept={props?.accept} referenceCodeItem={referenceCodeItem}/>
                <ListUploadFile referenceCodeItem={referenceCodeItem}/>
            </div>
        </DocumentContext.Provider>
    );
};

SimpleDocument.prototype = {
    externalReferenceCode: PropTypes.string.isRequired,
    moduleId: PropTypes.string.isRequired,
    appId: PropTypes.string.isRequired,
    readOnly: PropTypes.bool
}

export default SimpleDocument;
